"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    UsersSolid: function() {
        return UsersSolid;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const UsersSolid = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsxs)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
        /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M4 6C4 3.79086 5.79086 2 8 2C10.2091 2 12 3.79086 12 6C12 8.20914 10.2091 10 8 10C5.79086 10 4 8.20914 4 6Z",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M14 8C14 6.34315 15.3431 5 17 5C18.6569 5 20 6.34315 20 8C20 9.65685 18.6569 11 17 11C15.3431 11 14 9.65685 14 8Z",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
            d: "M15.7322 22H21.9998C22.552 22 22.9998 21.5523 22.9998 21V18C22.9998 14.6863 20.3135 12 16.9998 12C15.9295 12 14.9245 12.2806 14.0547 12.7715C14.3345 13.0953 14.5886 13.4415 14.814 13.8071C15.5662 15.0277 15.9998 16.4663 15.9998 18V21C15.9998 21.3643 15.9024 21.7058 15.7322 22Z",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
            d: "M8 11C4.13401 11 1 14.134 1 18V21C1 21.5523 1.44772 22 2 22H14C14.5523 22 15 21.5523 15 21V18C15 16.6568 14.6207 15.3992 13.9629 14.3318C12.7321 12.3348 10.5224 11 8 11Z",
            fill: "currentColor"
        })
    ]
}), "UsersSolid");
const _default = UsersSolid;
